<span>{{ time | uiKitTimerFormat: translationKey }}</span>
